<template>
  <el-button
    class="hide-btn"
    :class="dynamicClass"
    ref="aside"
    type="primary"
    @click="(e) => $emit('toggle', e)"
  >
    <el-icon
      size="32"
      name="i-hide-panel-o--24"
    />
  </el-button>
</template>

<script>
export default {
  name: 'ShowAsideButton',
  props: {
    isShow: {
      type: Boolean,
      default: true
    },
    mirrored: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dynamicClass() {
      if (this.isShow === undefined) {
        return ''
      }
      return this.mirrored ? !this.isShow : this.isShow
    },
  },
};
</script>

<style lang="scss" scoped>
.hide-btn {
  position: fixed;
  bottom: 60px;
  right: 16px;
  z-index: 1600;
  border-radius: 50%;
  padding: 8px 12px;
  width: 60px;
  height: 60px;
  opacity: 0.67;
  transition: 0.3s;
  transform: rotate(0);

  &.rotate {
    transform: rotate(180deg);
  }

  &.trackbar {
    transform: rotate(90deg);
    bottom: 100px;
    left: 10px;
  }

  &.trackbar.rotate {
    transform: rotate(-90deg);
  }
}
</style>
